/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AdminThreadsControllerFindOneQueryResponse, AdminThreadsControllerFindOnePathParams, AdminThreadsControllerFindOneQueryParams } from "../../models/adminThreadsController/AdminThreadsControllerFindOne";

function getAdminThreadsControllerFindOneUrl(threadId: AdminThreadsControllerFindOnePathParams["threadId"]) {
  const res = { method: 'GET', url: `/api/v1/admin/threads/${threadId}` as const }  
  return res
}

/**
 * @summary Read a customer thread and its conversation history
 * {@link /api/v1/admin/threads/:threadId}
 */
export async function adminThreadsControllerFindOne(threadId: AdminThreadsControllerFindOnePathParams["threadId"], params?: AdminThreadsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AdminThreadsControllerFindOneQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getAdminThreadsControllerFindOneUrl(threadId).url.toString(), params, ... requestConfig })  
  return res.data
}